import { Component } from "react";

export default class InfoTile extends Component {
  render() {
    let width = this.props.width ? this.props.width : "33%";
    let middleText = this.props.midleText ? (
      <div>&nbsp;{this.props.midleText}&nbsp;</div>
    ) : undefined;

    return (
      <div style={{ width: width }}>
        <div
          style={{
            padding: "4px",
            margin: "2px",
            backgroundColor: "rgb(57, 90, 90)",
            color: "#fff",
            display: "flex",
            textAlign: "center",
            flexDirection: "column",
          }}
        >
          <div>{this.props.topText}</div>
          {middleText}
          <div>{this.props.bottomText}</div>
        </div>
      </div>
    );
  }
}
